import {ReactNode} from 'react';

import {AppButton} from '@/components/Button';
import CloseButton from '@/components/CloseButton/CloseButton';
import {twx} from '@/utils/tailwindUtils';

export interface InlineNotificationProps {
    className?: string;
    iconWrapperClassName?: string;
    title?: ReactNode;
    body?: ReactNode;
    actionLabel?: string;
    onAction?: () => void;
    children?: ReactNode;
    onClose?: () => void;
    icon?: ReactNode;
    role?: string;
    'aria-live'?: 'polite' | 'assertive' | 'off';
    closeButtonProps?: any;
}

const InlineNotification = ({
    className,
    iconWrapperClassName,
    title,
    body,
    actionLabel,
    onAction,
    children,
    onClose,
    icon,
    role = 'alert',
    'aria-live': ariaLive = 'polite',
    closeButtonProps,
}: InlineNotificationProps) => {
    return (
        <div
            role={role}
            aria-live={ariaLive}
            className={twx(
                'relative flex w-full flex-col gap-4 rounded-xl bg-primary-dark-5 p-4 @2xl/inline-notification:flex-row @2xl/inline-notification:justify-between',
                className
            )}
        >
            <div className='flex flex-1 items-center gap-2 text-start'>
                {icon && <div className={twx('p-2', iconWrapperClassName)}>{icon}</div>}
                <div className='flex min-w-0 flex-1 flex-col text-primary-dark'>
                    {title && <p className='text-16 font-bold leading-[24px]'>{title}</p>}
                    {body && <p className='text-14 leading-[20px] tracking-04'>{body}</p>}
                </div>
            </div>
            {actionLabel && (
                <AppButton
                    secondary
                    light
                    onClick={onAction}
                    className='m-0 self-start @2xl/inline-notification:w-auto'
                >
                    {actionLabel}
                </AppButton>
            )}
            {children}
            {onClose && (
                <CloseButton onClick={onClose} className='absolute right-1 top-1' size='small' {...closeButtonProps} />
            )}
        </div>
    );
};

export default InlineNotification;
